module.exports = __webpack_public_path__ + "img/DE01766.20674324.png";